import PidDetail from '../container/detail/PidDetail';

function PidDetailPage() {
  return <PidDetail />;
}
export default PidDetailPage;
